var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row my-4" }, [
      _c("div", { staticClass: "container my-auto" }, [
        _c("header", { staticClass: "my-4" }, [
          _c("img", {
            staticClass: "mx-auto d-block",
            attrs: { src: "/images/" + _vm.logo, alt: "Logo" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card card-signin mx-auto my-4" }, [
          !_vm.isPasswordBeingReset
            ? _c("div", { staticClass: "card-body" }, [
                _c("h5", { staticClass: "card-title text-center" }, [
                  _vm._v(
                    "\n            Aanmelden bij " +
                      _vm._s(_vm.applicationName) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "form-signin",
                    attrs: { method: "post", action: "/login" }
                  },
                  [
                    _c("div", { staticClass: "form-label-group" }, [
                      _c("label", { attrs: { for: "username" } }, [
                        _vm._v("Gebruikersnaam")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.username,
                            expression: "username"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          disabled: _vm.loading,
                          type: "text",
                          id: "username",
                          name: "username",
                          placeholder: "Gebruikersnaam",
                          required: "",
                          autofocus: ""
                        },
                        domProps: { value: _vm.username },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-label-group" }, [
                      _c("label", { attrs: { for: "password" } }, [
                        _vm._v("Wachtwoord")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group" }, [
                        !_vm.isPasswordVisible
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                disabled: _vm.loading,
                                type: "password",
                                name: "password",
                                id: "password",
                                placeholder: "Wachtwoord",
                                required: ""
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                disabled: _vm.loading,
                                type: "text",
                                name: "password",
                                id: "password",
                                placeholder: "Wachtwoord",
                                required: ""
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value
                                }
                              }
                            }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "input-group-append",
                            on: { click: _vm.togglePasswordVisibility }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "input-group-text bg-transparent"
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "float-left",
                                  attrs: { icon: ["fad", _vm.iconText] }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "my-1 mx-1" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-primary",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.showForgotPassword($event)
                            }
                          }
                        },
                        [_vm._v("Wachtwoord vergeten?")]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "ehr-button",
                      {
                        staticClass: "btn-block mt-4",
                        attrs: {
                          "button-type-class": "btn-primary",
                          loading: _vm.loading,
                          icon: "sign-in"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.doLogin($event)
                          }
                        }
                      },
                      [_vm._v("\n              Aanmelden\n            ")]
                    )
                  ],
                  1
                )
              ])
            : _c("div", { staticClass: "card-body" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-primary",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.hideForgotPassword($event)
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["far", "arrow-left"] }
                    }),
                    _vm._v("\n            Vorige\n          ")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h5", { staticClass: "card-title text-center" }, [
                  _vm._v("Wachtwoord vergeten?")
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "form-signin",
                    attrs: { method: "post", action: "/login" }
                  },
                  [
                    _c("div", { staticClass: "form-label-group" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.resetEmail,
                            expression: "resetEmail"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          disabled: _vm.loading,
                          type: "text",
                          id: "resetEmail",
                          name: "resetEmail",
                          placeholder: "E-mailadres",
                          required: "",
                          autofocus: ""
                        },
                        domProps: { value: _vm.resetEmail },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.resetEmail = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "ehr-button",
                      {
                        staticClass: "btn-block mt-4",
                        attrs: {
                          "button-type-class": "btn-primary",
                          loading: _vm.loading,
                          icon: "envelope",
                          disabled: _vm.$v.resetEmail.$invalid
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.requestNewPasswordForEmail($event)
                          }
                        }
                      },
                      [_vm._v("\n              Stuur mail\n            ")]
                    )
                  ],
                  1
                )
              ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "alert alert-primary my-3", attrs: { role: "alert" } },
      [
        _vm._v(
          "\n            Gelieve uw e-mailadres in voeren dat geassocieerd is aan uw\n            account."
        ),
        _c("br"),
        _vm._v(
          "\n            We sturen u dan een e-mail met een link om uw wachtwoord opnieuw\n            in te stellen.\n          "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "username" } }, [
      _c("strong", [_vm._v("E-mail geassocieerd aan account:")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }